import BoardListItem from './BoardListItem';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Collapse, List, ListItem, ListItemText } from '@mui/material';
import { BoardID } from 'BoardID';
import React, { useState } from 'react';

function BoardListSection(props: {
  boardIDs: Array<BoardID>;
  initialState?: boolean;
  name: string;
  secondaryAction?: React.ReactNode;
}) {
  const { boardIDs, initialState = true, name, secondaryAction } = props;

  const [isOpen, setIsOpen] = useState(initialState);

  return (
    <>
      <ListItem
        component="div"
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: 'pointer' }}
        secondaryAction={
          <ExpandMore
            style={{
              transform: `rotate(${isOpen ? 0 : 90}deg)`,
              transition: 'transform 300ms ease',
            }}
          />
        }
      >
        <ListItemText
          primary={
            <div
              style={{
                display: 'flex',
                minWidth: 0,
              }}
            >
              <div
                style={{
                  gap: '.5rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  minWidth: 0,
                }}
              >
                {name}&nbsp;
              </div>
              <div> ({boardIDs.length})</div>
              {secondaryAction && (
                <div style={{ marginLeft: '0.5rem' }}>{secondaryAction}</div>
              )}
            </div>
          }
          primaryTypographyProps={{ variant: 'button' }}
        />
      </ListItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="nav">
          {boardIDs.map((boardID) => (
            <BoardListItem boardID={boardID} key={boardID} />
          ))}
        </List>
      </Collapse>
    </>
  );
}

export default BoardListSection;
